import { Component, Input, Output, EventEmitter } from '@angular/core';

/**
 * Shared response-share component for agents only.
 * Share button only – same size and style as chatbot share.
 */
@Component({
  selector: 'app-shared-response-share',
  templateUrl: './response-share.component.html',
  styleUrls: ['./response-share.component.scss']
})
export class SharedResponseShareComponent {
  @Input() disabled = false;
  /** When false, hide share button (per-agent config). Default true. */
  @Input() showShare = true;
  @Input() isAgent: boolean = false;
  @Output() shareClick = new EventEmitter<void>();

  onShareClick(): void {
    if (!this.disabled) this.shareClick.emit();
  }
}
